import React, { Component } from 'react';
import { Settings } from 'screens/users/components/Settings';
import { Elements } from 'react-stripe-elements';



class UserSettings extends Component {

  render() {

    return (
      <Elements>
        <Settings />
      </Elements>
    )
  }
}



export { UserSettings };


// WEBPACK FOOTER //
// ./src/screens/users/scenes/UserSettings.js